import { StateCreator } from "zustand/index";
import { PcpLiveLessonState } from "../pcpLiveLessonStore.interface";
import { usePcpLiveLessonContext, usePcpLiveLessonStore } from "../PcpLiveLessonStoreContext";

export interface PcpChatThreadSlice {
    chatThreadState: PcpChatThreadState;

    updateGroupChatThreadId: (threadId: string) => void;
    setActiveThreadId: (threadId: undefined | string) => void;
    setAskTeacherThreadId: (threadId: undefined | string) => void;
}

export interface PcpChatThreadState {
    activeThread?: string;
    groupChat?: string;
    privateChats: string[];
    askTeacherThread?: string;


}

export const createChatThreadSlice: StateCreator<
    PcpLiveLessonState,
    [["zustand/immer", never]],
    [],
    PcpChatThreadSlice
> = (set) => ({

    chatThreadState: {
        activeThread: undefined,
        groupChat: undefined,
        privateChats: [],
        askTeacherThread: undefined,
    },

    updateGroupChatThreadId: (threadId: string) => {
        set(state => {
            const currentChatThreadState = state.chatThreadState;
            const isGroupChatActivated = currentChatThreadState.activeThread === currentChatThreadState.groupChat;

            state.chatThreadState.groupChat = threadId;
            // state.chatThreadState.activeThread = threadId;

            if (isGroupChatActivated) {
                state.chatThreadState.activeThread = threadId;
            }
        });
    },

    setActiveThreadId: (threadId: undefined | string) => {
        set(state => {
            state.chatThreadState.activeThread = threadId;
        });
    },

    // setAskTeacherThreadId: (threadId: undefined|string) => set(produce(state => {
    //     state.chatThreadState.askTeacherThread = threadId;
    // })),

    setAskTeacherThreadId: (threadId: undefined | string) => {
        set(state => ({
            chatThreadState: {
                ...state.chatThreadState,
                askTeacherThread: threadId,
            },
        }));
    },
});


export const usePcpChatThreadState = (): PcpChatThreadState => usePcpLiveLessonContext(s => s.chatThreadState);


/**
 * Öffentliche Schnittstelle zur Verwaltung von Chat-Threads.
 */
export const usePcpChatThreadManager = () => {
    const store = usePcpLiveLessonStore();

    const updateGroupChatThreadId = usePcpLiveLessonContext(s => s.updateGroupChatThreadId);
    const setActiveThreadId = usePcpLiveLessonContext(s => s.setActiveThreadId);
    const setAskTeacherThreadId = usePcpLiveLessonContext(s => s.setAskTeacherThreadId);

    const state = usePcpLiveLessonContext(s => s.chatThreadState);




    return {
        activateChat: (threadId: string) => setActiveThreadId(threadId),
        deactivateChat: () => setActiveThreadId(undefined),
        setAskTeacherThreadId: (threadId?: string) => setAskTeacherThreadId(threadId),
        activateAskTeacherThread: () => setActiveThreadId(state.askTeacherThread),
        activateGroupChat: () => setActiveThreadId(state.groupChat),
    };
};
